import shortUUID from 'short-uuid';

if (Drupal.api == null) {
  Drupal.api = {};
}

Drupal.api.wishlistclient = () => {
  return {
    wishlistId: null,
    wishlistName: null,
    wishlistUuid: null,
    wishlists: [],
    wishlistItems: [],
    wishlistIsLoaded: false,
    wishlistItemsIsLoaded: false,
    csrfToken: null,

    getToken() {
      return fetch('/session/token')
        .then((response) => {
          return response.text();
        })
        .then((token) => {
          this.csrfToken = token;
        });
    },

    createWishlist(wishlistname, items) {
      if (wishlistname.length > 0) {
        this.getToken().then(() => {
          fetch(`/better-wishlist/create`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-CSRF-TOKEN': this.csrfToken,
            },
            method: 'POST',
            body: JSON.stringify({
              name: wishlistname,
            }),
          }).then((response) => {
            return response.json().then((wishlist) => {
              this.wishlists.push(wishlist);
              this.setWishlist(wishlist);
              const storedUuidsString = localStorage.getItem('better_wishlists') || '[]';
              const storedUuids = JSON.parse(storedUuidsString);
              storedUuids.push(wishlist.uuid);
              localStorage.setItem('better_wishlists', JSON.stringify(storedUuids));
              this.addWishlistItem(wishlist.uuid, items);
            });
          });
        });
      }
    },

    deleteWishlist(wishlistUuid) {
      this.getToken().then(() => {
        fetch(`/better-wishlist/delete?_format=json`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-TOKEN': this.csrfToken,
          },
          method: 'POST',
          body: JSON.stringify({ uuid: wishlistUuid }),
        }).then((response) => {
          return response.json().then(() => {
            this.getWishlists();
          });
        });
      });
    },

    areEmptyWishlists() {
      return this.wishlists.length === 0;
    },

    getWishlists() {
      this.getToken().then(() => {
        const storedUuids = localStorage.getItem('better_wishlists')
          ? JSON.parse(localStorage.getItem('better_wishlists'))
          : '';
        if (storedUuids !== '') {
          fetch(`/better-wishlist/wishlists?_format=json&uuids=${storedUuids.join('+')}`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-CSRF-TOKEN': this.csrfToken,
            },
            method: 'GET',
          }).then((response) => {
            return response.json().then((wishlists) => {
              console.log(wishlists);
              this.wishlists = wishlists;
              this.wishlistIsLoaded = true;
            });
          });
        }
      });
    },

    setWishlist(wishlist) {
      this.wishlistName = wishlist.name;
      this.wishlistUuid = wishlist.uuid;
    },

    getIds(items) {

      const itemsIds = [];
      items.forEach((item) => {
        if (item.variation_id) {
          itemsIds.push(item.variation_id);
        } else {
          itemsIds.push(item);
        }
      });
      return itemsIds;
    },

    removeWishlistItem(wishlistUuid, items) {
      const entityIds = this.getIds(items);
      this.postFetchItems('/better-wishlist/remove-from', wishlistUuid, entityIds);
    },

    addWishlistItem(wishlistUuid, items) {
      const entityIds = this.getIds(items);
      this.postFetchItems('/better-wishlist/add-to', wishlistUuid, entityIds);
    },

    postFetchItems(url, wishlistUuid, entityIds) {
      this.getToken().then(async () => {
        for await (const entityId of entityIds) {
          await fetch(url, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-CSRF-TOKEN': this.csrfToken,
            },
            method: 'POST',
            body: JSON.stringify({
              uuid: wishlistUuid,
              entity_type: 'commerce_product_variation',
              entity_id: entityId,
            }),
          });
        }
        this.getWishlistItems(wishlistUuid);
      });
    },

    getWishlistItems(wishlistUuid) {
      this.wishlistItems = [];
      this.getToken().then(() => {
        fetch(`/better-wishlist/wishlistitems?_format=json&uuid=${wishlistUuid}`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-TOKEN': this.csrfToken,
          },
          method: 'GET',
        }).then((response) => {
          return response.json().then((wishlistItems) => {
            this.wishlistItems = wishlistItems;
          });
        });
      });
    },

    areEmptyWishlistItems() {
      return this.wishlistItems.length === 0;
    },
  };
};
